import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://radiant-achievement-production.up.railway.app';
// const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5858/api';

const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401 && localStorage.getItem('token')) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
